import { IItem, instanceOfIItem } from "./IItem";

export interface IJoinTextAssosiatable extends IItem {
  name: string;
  text(): string;
}

export function instanceOfIJoinTextAssosiatable(instance: any): instance is IJoinTextAssosiatable {
  return (instance != null)
//    && (instance.name !== undefined)
    && (instance.text !== undefined)
    && (typeof instance.text === "function")
    && instanceOfIItem(instance);
}
